export const numberFormatter = (value: number | string | undefined | null, currency: string = ''): string => {
  let finalValue;
  switch (typeof value) {
    case 'string':
      finalValue = Number(value);
      break;
    case 'number':
      finalValue = value;
      break;
    default:
      finalValue = 0.0;
      break;
  }
  const [int, dec] = finalValue.toFixed(2).split('.');
  return `${currency}${int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${dec}`;
};

export const numberFormatterDiffCredit = (
  value: number | string | undefined | null,
  currency: string = '',
  valueDiff: number | any,
): string => {
  let finalValue;
  switch (typeof value) {
    case 'string':
      finalValue = Number(value);
      break;
    case 'number':
      finalValue = value;
      break;
    default:
      finalValue = 0.0;
      break;
  }
  const newValue = finalValue - valueDiff > 0 ? finalValue - valueDiff : 0;
  const [int, dec] = newValue.toFixed(2).split('.');
  return `${currency}${int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${dec}`;
};
